import LocalImages from "assets/images/local-images";
import Body from "features/shared/styles/typography/Body.styled";
import { ButtonTitle } from "features/shared/styles/typography/ButtonTitle.styled";
import { SmallPrint } from "features/shared/styles/typography/SmallPrint.styled";
import { Summary } from "features/shared/styles/typography/Summary.styled";
import { FC } from "react";

import StyledVisaBanner from "./styles/StyledVisaBanner.styled";
import VisaBannerContent from "./styles/VisaBannerContent.styled";
import VisaBannerLink from "./styles/VisaBannerLink.styled";

export interface VisaBannerClientProps {
  title: string;
  description: string;
  footer: string;
  buttonText: string;
  isButtonVisible: boolean;
  onClick: () => void;
}

const VisaBannerClient: FC<VisaBannerClientProps> = ({
  title,
  description,
  footer,
  buttonText,
  isButtonVisible,
  onClick,
}) => {
  const images = LocalImages.shared.images;

  return (
    <StyledVisaBanner>
      <img alt="" src={images.icons.banner.info} />

      <VisaBannerContent>
        <Summary>{title}</Summary>
        <Body>{description}</Body>
        {isButtonVisible ? (
          <>
            <SmallPrint>{footer}</SmallPrint>
            <VisaBannerLink type="button" onClick={onClick}>
              <ButtonTitle>{buttonText}</ButtonTitle>
              {/* only VIVA's card shell shows this - see StyledVisaBanner-*.styled.ts */}
              <img
                className="visa-banner-cta-arrow"
                width={16}
                height={16}
                src={images.icons.externalLink ?? images.icons.chevron.right}
                alt=""
              />
            </VisaBannerLink>
          </>
        ) : null}
      </VisaBannerContent>
    </StyledVisaBanner>
  );
};

export default VisaBannerClient;
